import { createIcon } from './icon-utils';

export const SubmitFieldPlusIcon = createIcon({
  path: 'M12.001 23.247c-6.213 0-11.25-5.037-11.25-11.25S5.788.747 12.001.747s11.25 5.037 11.25 11.25-5.037 11.25-11.25 11.25zm0-1.5c5.385 0 9.75-4.365 9.75-9.75s-4.365-9.75-9.75-9.75-9.75 4.365-9.75 9.75 4.365 9.75 9.75 9.75zm.749-10.497h3.5c.414 0 .75.336.75.75s-.336.75-.75.75h-3.5v3.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-3.5h-3.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.5v-3.5c0-.414.336-.75.75-.75s.75.336.75.75v3.5z',
});
